import styled from 'styled-components';
import type { Theme } from '@web-chat-core/ui-kit';
import { mobile, tablet } from '@web-chat-core/ui-kit';

export const HorizontalScroll = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    height: inherit;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-gutter: stable;

    @media all and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
        & > * {
            -webkit-margin-before: -6px;
            -webkit-margin-after: -6px;
        }
    }

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        background-color: transparent;
        height: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
        transition: background 0.2s;
    }

    &:hover::-webkit-scrollbar {
        -webkit-appearance: auto;
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.root.colors.basicColors['10%']};
    }

    &:hover {
        & > * {
            -webkit-margin-before: -6px;
        }
    }

    ${tablet`
        &:hover::-webkit-scrollbar-thumb {
            background-color: ${({ theme }: { theme: Theme }) => theme.root.colors.basicColors['10%']};
        }
    `}

    ${mobile`
        &:hover::-webkit-scrollbar-thumb {
            background-color: ${({ theme }: { theme: Theme }) => theme.root.colors.basicColors['10%']};
        }
    `}
`;

export const VerticalScroll = styled.div`
    width: 100%;
    height: inherit;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-gutter: stable both-edges;

    @media all and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
        & > * {
            -webkit-margin-end: -6px;
            -webkit-margin-start: -6px;
        }
    }

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
        transition: background 0.2s;
    }

    &:hover::-webkit-scrollbar {
        -webkit-appearance: auto;
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.root.colors.basicColors['10%']};
    }

    ${tablet`
        &:hover::-webkit-scrollbar-thumb {
            background-color: ${({ theme }: { theme: Theme }) => theme.root.colors.basicColors['10%']};
        }
    `}

    ${mobile`
        &:hover::-webkit-scrollbar-thumb {
            background-color: ${({ theme }: { theme: Theme }) => theme.root.colors.basicColors['10%']};
        }
    `}
`;
